import { render, staticRenderFns } from "./RELTempoDePlaca.vue?vue&type=template&id=9e4c04de&"
import script from "./RELTempoDePlaca.vue?vue&type=script&lang=js&"
export * from "./RELTempoDePlaca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports